import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Grid, TextField, FormControl, InputLabel, Select, MenuItem, Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import Autocomplete from '@mui/material/Autocomplete';
const LineItemsLogFilters = ({ meta, onFilterChange, onSearchSubmit, onReset }) => {
    const skusList = useSelector(state => state.lineItemsLog?.skusList || []);
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        onFilterChange({ [name]: value, page: 1 }); 
    };

    return (
        <div> 
            <Box sx={{ p: 2.5, backgroundColor: '#FAFAFA' }}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={2.5}>
                        <Autocomplete
                            size="small"
                            options={skusList} // Fed directly from backend response state list array
                            value={meta.search || null}
                            onChange={(event, newValue) => {
                                // Fires state modifier callbacks immediately upon select change
                                onFilterChange({ search: newValue || "" });
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Search SKU"
                                    placeholder="Select or type SKU..."
                                    InputProps={{
                                        ...params.InputProps,
                                        startAdornment: (
                                            <>
                                                <SearchIcon sx={{ color: '#94A3B8', fontSize: 18, mr: 0.5 }} />
                                                {params.InputProps.startAdornment}
                                            </>
                                        ),
                                    }}
                                    sx={{ 
                                        '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E8F0' }, 
                                        '& .MuiOutlinedInput-root': { 
                                            borderRadius: '10px', 
                                            backgroundColor: '#FFFFFF',
                                            padding: '4.5px 14px !important' // Vertically centers the elements nicely
                                        } 
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    
                    <Grid item xs={12} sm={2}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="log-event-select-label">Activity Type</InputLabel>
                            <Select
                                labelId="log-event-select-label"
                                name="event"
                                value={meta.event || 'ALL'}
                                label="Activity Type"
                                onChange={handleInputChange}
                                sx={{ borderRadius: '10px', backgroundColor: '#FFFFFF', '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E8F0' } }}
                            >
                                <MenuItem value="ALL">All Activities</MenuItem>
                                <MenuItem value="stock_update">Stock Update</MenuItem>
                                <MenuItem value="order_out">Order Out</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* <Grid item xs={12} sm={2}>
                        <FormControl fullWidth size="small">
                            <InputLabel id="log-source-select-label">Source Channel</InputLabel>
                            <Select
                                labelId="log-source-select-label"
                                name="source"
                                value={meta.source || 'ALL'}
                                label="Source Channel"
                                onChange={handleInputChange}
                                sx={{ borderRadius: '10px', backgroundColor: '#FFFFFF', '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E8F0' } }}
                            >
                                <MenuItem value="ALL">All Channels</MenuItem>
                                <MenuItem value="UI">UI Workspace</MenuItem>
                                <MenuItem value="API">API Gateway</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid> */}

                    <Grid item xs={12} sm={1.75}>
                        <TextField
                            fullWidth
                            size="small"
                            type="date"
                            name="start_date"
                            label="Start Date"
                            InputLabelProps={{ shrink: true }}
                            value={meta.start_date || ''}
                            onChange={handleInputChange}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px', backgroundColor: '#FFFFFF' }, '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E8F0' } }}
                        />
                    </Grid>

                    <Grid item xs={12} sm={1.75}>
                        <TextField
                            fullWidth
                            size="small"
                            type="date"
                            name="end_date"
                            label="End Date"
                            InputLabelProps={{ shrink: true }}
                            value={meta.end_date || ''}
                            onChange={handleInputChange}
                            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '10px', backgroundColor: '#FFFFFF' }, '& .MuiOutlinedInput-notchedOutline': { borderColor: '#E2E8F0' } }}
                        />
                    </Grid>

                    {/* ACTION INTERACTION ACTIONS SECTION */}
                    <Grid item xs={12} sm={2} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Button 
                            fullWidth 
                            onClick={onSearchSubmit} 
                            variant="contained" 
                            size="small" 
                            sx={{ 
                                textTransform: 'none', 
                                backgroundColor: '#1976d2', 
                                color: '#FFFFFF', 
                                fontWeight: 700, 
                                fontSize: '13px', 
                                height: '36px',
                                borderRadius: '8px',
                                boxShadow: 'none',
                                '&:hover': { backgroundColor: '#115293', boxShadow: 'none' }
                            }}
                        >
                            Submit
                        </Button>
                        <Button 
                            fullWidth 
                            onClick={onReset} 
                            variant="text" 
                            size="small" 
                            sx={{ textTransform: 'none', color: '#64748B', fontWeight: 700, fontSize: '13px', height: '36px' }}
                        >
                            Reset
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </div>
    );
};

export default LineItemsLogFilters;